import { FaBars as MidExpandIcon } from 'react-icons/fa';

export default MidExpandIcon;
